import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { ExitViewModule } from '../../shared/components/exit-view/exit-view.component.module';
import { PageHeaderModule } from '../../shared/components/header/page-header/page-header.module';
import { AssessmentsDataEntryModule } from './assessments/assessments-data-entry.module';
import { DataEntryHeaderComponent } from './data-entry-header/data-entry-header.component';
import { DataEntryLeftNavComponent } from './data-entry-left-nav/data-entry-left-nav.component';
import { DataEntryComponent } from './data-entry.component';

@NgModule({
  imports: [CommonModule, ExitViewModule, NvDesignLibraryModule, AssessmentsDataEntryModule, PageHeaderModule],
  declarations: [DataEntryComponent, DataEntryHeaderComponent, DataEntryLeftNavComponent],
  exports: [DataEntryComponent, DataEntryHeaderComponent, DataEntryLeftNavComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DataEntryModule {}
